import { ThemeUICSSObject, spacing } from '@apia/theme';
/* IMPORT HERE */

const list: ThemeUICSSObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: spacing(3),
  '.notification': {
    borderRadius: '4px',
    boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
  },
  /* PREPEND HERE */
};

export default list;
